module.exports = __webpack_public_path__ + "static/media/intro-en-ru.22e604f7.vtt";